<mat-dialog-content class="dialog-content">
  <mg-whats-new (done)="close()"></mg-whats-new>
</mat-dialog-content>
